import {
    Component, ElementRef, HostBinding, HostListener,
    Input, OnInit, Renderer} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { MenuItem, MenuService } from '../services/menu.service';
import { BreadcrumService, BreadcrumStep } from '../services/breadcrum.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'fw-menu-item',
    template: require('./menu-item.component.html'),
    styles: [require('./menu-item.component.css')]
})
export class MenuItemComponent implements OnInit {
    private activeMenuItemSubscription: Subscription;
    @Input() item = <MenuItem>null;
    isActiveMenuItem = false;
    mouseInItem = false;

    constructor(private router: Router,
        private menuService: MenuService,
        private breadcrumService: BreadcrumService,
        private el: ElementRef,
        private renderer: Renderer) {
    }

    checkActiveRoute() {
        this.isActiveMenuItem = (this.menuService.activeMenuItem == this.item);
        if (this.isActiveMenuItem) {
            var steps: Array<BreadcrumStep> = [
                { text: 'hoofdmenu', isLastStep: false },
                { text: this.item.text, isLastStep: true }];
            this.breadcrumService.setCurrentLocation(steps, false, '');
        }
    }

    ngOnInit(): void {
        this.checkActiveRoute();

        this.activeMenuItemSubscription = this.menuService.activeMenuItemChanged
            .subscribe((event) => {
                this.checkActiveRoute();
            });
    }

    ngOnDestroy(): void {
        this.activeMenuItemSubscription.unsubscribe();
    }

    @HostListener('click', ['$event'])
    onClick(event): void {

        event.stopPropagation();

        if (this.item.route) {
            this.router.navigate(['/' + this.item.route]);
        } else if (this.item.submenu != null) {
            this.menuService.setActiveMenuItem(this.item);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/menu/menu-item.component.ts